import { data } from 'services';
import { getSource2, getDateTime } from 'services/types';

export const getTableParams = (t) => {
  const getFields = () => {
    const fields = [
      { name: 'timestamp', sortField: 'timestamp', title: t('grid.Дата и время'), width: 210, render: (val) => getDateTime(val) },
      { name: 'message', title: t('inputs.Описание'), fullh: true },
      {
        name: 'type',
        title: t('dict_filter.Приоритет'),
        width: 140,
        render: (val) => data.getDictValue('events.type', val),
      },
      {
        name: 'source_type',
        title: t('grid.Источник'),
        width: 120,
        render: (val) => data.getDictValue('rack_type', val),
      },
      {
        name: 'source',
        title: t('grid.№ устройства'),
        width: 140,
        render: (val) => getSource2(val),
      },
    ];

    if (window.config.central) {
      fields.unshift({
        name: 'parking_id',
        title: t('grid.Парковка'),
        render: (val) => <ParkingCell parking_id={val} cmp={'span'} />,
        width: 'auto',
      });
    }

    return fields;
  };

  return { getFields };
};
